export default __webpack_public_path__ + "static/media/AG05a.ab8c9d1b.mp3";